<span *ngIf="phxPrefixTemplate" class="phx-button-prefix" [class.phx-button-loading]="phxLoading">
  <ng-container [ngTemplateOutlet]="phxPrefixTemplate"></ng-container>
</span>
<i
  *ngIf="phxPrefixIcon && !phxPrefixTemplate"
  phx-icon
  [disabled]="disabled"
  class="phx-button-prefix"
  [class.phx-button-loading]="phxLoading"
  [phxIcon]="phxPrefixIcon"
  color="currentColor"
></i>
<i *ngIf="phxLoading" phx-icon [phxIcon]="circleLoadingIcon" color="currentColor" class="phx-button-loading-icon"></i>
<span class="phx-button-content" [class.phx-button-loading]="phxLoading">
  <ng-content></ng-content>
</span>
<span *ngIf="phxSuffixTemplate" class="phx-button-suffix" [class.phx-button-loading]="phxLoading">
  <ng-container [ngTemplateOutlet]="phxSuffixTemplate"></ng-container>
</span>
<i
  *ngIf="phxSuffixIcon && !phxSuffixTemplate"
  phx-icon
  [disabled]="disabled"
  class="phx-button-suffix"
  [class.phx-button-loading]="phxLoading"
  [phxIcon]="phxSuffixIcon"
  color="currentColor"
></i>
<ng-content select="[phx-icon-badge]"></ng-content>